export default __webpack_public_path__ + "static/media/s0_male.51bc2177.wav";